import { Divider, Pagination, Stack, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { TailSpin } from 'react-loader-spinner';
import { adminAxiosInstance, axiosInstance } from 'src/api/axios';
import PageContainer from 'src/components/container/PageContainer';
import AdminPermissionsTable from '../dashboard/components/AdminPermissionsTable';

// The Admins management page is restricted to users who are BOTH a super_admin
// AND hold the manage_roles permission (not just one of them).
const canManageAdmins = () => {
  try {
    const store = localStorage.getItem('store');
    const user = store ? JSON.parse(store)?.user : null;
    const perms = user?.permissions || [];
    return user?.role === 'super_admin' && perms.includes('manage_roles');
  } catch (e) {
    return false;
  }
};

const AdminPermissionsPage = () => {
    const [allowed] = useState(canManageAdmins);
    const [users, setUsers] = useState([]);
     const [page, setPage] = useState(1);
     const [count, setCount] = useState(0);
     const [loader, setLoader] = useState(false);
     const [permissionList, setPermissionList] = useState([]);

     const getUsers = useCallback(() => { 
         adminAxiosInstance.get('/users/admins')
         .then((res) => { 
             if (res.status < 210) { 
                 setUsers(res.data);
             } 
         }); 
         }, [page]);
     useEffect(()=>{
       if(!allowed){
         return;
       }
       getUsers();
       if(!permissionList.length){
              const saved_permissons = localStorage.getItem('permissions');
            if(!saved_permissons){
             axiosInstance.get('/misc/permissions')
             .then((res)=>{
                 let {permissions} = res.data;
                 permissions = permissions.filter((perm)=>!perm.includes('roles'))
                 setPermissionList(permissions);
                  localStorage.setItem('permissions', JSON.stringify(permissions));
             })
             .catch((err)=>{
                 console.error("Error fetching allowed features:", err);
             });
           }
            else{
              setPermissionList(JSON.parse(saved_permissons));
          }
        }
       },[])

// Predefined permissions that can be assigned const predefinedPermissions = [ 'dashboard_access', 'user_management', 'product_management', 'report_access', 'transaction_access', 'campaign_management', 'analytics_access', 'admin_settings' ];

const updateUserPermissions = (userId, permission, role) => {
     setLoader(true);
      adminAxiosInstance.patch(
        `/users/admins/${userId}`,
         { permissions:permission, role: role }
        ) 
         .then((response) => {
             if ([200,201].includes(response.status)) {
                getUsers();
                setLoader(false); 
            }
            else{
              setLoader(false);
              alert('Failed to update user');
            }    
        }) 
        .catch(e => {
             console.log(e);
             setLoader(false); 
             alert('Failed to update user'); }); 
        }


if(!allowed){
  return <Navigate to="/auth/403" replace />;
}

return (
    <>
<PageContainer title="Admin Permissions Management" description="Manage user permissions within the admin panel">
  
      <Divider sx={{ my: 2 }} />
      {!loader ? (
        users?.length ? (
          <AdminPermissionsTable 
            users={users}
            predefinedPermissions={permissionList}
            onUpdatePermissions={updateUserPermissions}
          />
        ) : (
          <Stack
            justifyContent={'center'}
            alignItems={'center'}
            sx={{ width: '75vw', height: '30vh' }}
          >
            <Typography variant="h4" sx={{ textAlign: 'center' }}>
              No Users Found
            </Typography>
          </Stack>
        )
      ) : (
        <Stack
          justifyContent={'center'}
          alignItems={'center'}
          sx={{ width: '75vw', height: '55vh' }}
        >
          <TailSpin height={45} width={45} style={{ margin: 'auto', bg: '#444' }} />
        </Stack>
      )}
    
    
    <Stack direction="row" alignItems={'center'} justifyContent={'center'}>
      <Pagination
        count={Math.round(count / 100) + 1}
        onChange={(e, value) => setPage(value)}
      />
    </Stack>
    
    </PageContainer>
    </>

)
 };

export default AdminPermissionsPage;
